import { observable, makeObservable } from "mobx";

export default class ImagesStore {
  data = {};

  constructor() {
    makeObservable(this, {
      data: observable,
    });
  }
}
